import { api } from "@/modules/api";
import type {
  AgentActivityDetail,
  SearchAgentActivitiesRequest,
  SearchAgentActivitiesResponse,
} from "@/pages/agent/activities/agent-activity.types";
import { USER_FACING_AGENT_ACTIVITY_EXCLUDED_ITEM_KINDS } from "@/pages/agent/activities/agent-activity-visibility";

export const searchAgentActivities = async (
  request: SearchAgentActivitiesRequest
): Promise<SearchAgentActivitiesResponse> => {
  const response = await api.post("/v2/mem-agent-activities/search", {
    body: {
      ...request,
      exclude_item_kinds: USER_FACING_AGENT_ACTIVITY_EXCLUDED_ITEM_KINDS,
    },
  });

  if (response.error || !response.data) {
    throw new Error("Unable to load activity log");
  }

  return response.data;
};

export const getAgentActivity = async ({
  activityId,
}: {
  activityId: string;
}): Promise<AgentActivityDetail> => {
  const response = await api.get("/v2/mem-agent-activities/{activity_id}", {
    params: {
      path: { activity_id: activityId },
      query: {
        exclude_item_kinds: USER_FACING_AGENT_ACTIVITY_EXCLUDED_ITEM_KINDS,
      },
    },
  });

  if (response.error || !response.data) {
    throw new Error("Unable to load activity");
  }

  return response.data;
};
